import React from "react";
import { connect } from "react-redux";

import config from "../config/legalworks.frontend.config";

const entraRedirectUri = `https://${config.domain}/addedEntraAppSuccess`;

const EntraAppInitiateConsentUnconnected = () => {
	const lxwOutlookEntraApplicationID = "e217af14-28cb-4629-a6d7-bcb277b741f0";

	return (
		<div style={{ padding: 24 }}>
			<div style={{ fontWeight: "bold", marginBottom: 34 }}>
				Connect Microsoft Entra to LexWorkplace
			</div>
			<div>
				<a
					target="_blank"
					rel="noopener noreferrer"
					href={`https://login.microsoftonline.com/organizations/adminconsent?client_id=${lxwOutlookEntraApplicationID}&redirect_uri=${entraRedirectUri}`}
				>
					Click here
				</a>
				<span>
					{" "}
					to add the LexWorkplace for Outlook App Registration to your
					Microsoft 365 Organization (Entra ID)
				</span>
			</div>
		</div>
	);
};
const EntraAppConsentFinalDestinationUnconnected = () => {
	return (
		<div style={{ padding: 24 }}>
			<div style={{ fontWeight: "bold", marginBottom: 34 }}>
				Connect Microsoft Entra to LexWorkplace
			</div>
			<div>
				<span>
					{`✅ The LexWorkplace Application was successfully added to
					your Microsoft 365 organization.  You can find it in the Applications > Enterprise Applications section of Entra.`}
				</span>
			</div>
		</div>
	);
};
const mapStateToProps = (state) => ({
	cognitoSub: state?.user?.cognitoUser?.attributes?.sub,
});

const EntraAppInitiateConsent = connect(
	mapStateToProps,
	{}
)(EntraAppInitiateConsentUnconnected);
const EntraAppConsentFinalDestination = connect(
	mapStateToProps,
	{}
)(EntraAppConsentFinalDestinationUnconnected);

export { EntraAppInitiateConsent, EntraAppConsentFinalDestination };
